import React              from 'react'
import ReactDOM           from 'react-dom'
import BaseController     from 'controllers/base'
import ConfirmEligibility  from 'containers/ConfirmEligibility/App'

class Controller extends BaseController {
  call() {
    super.call()

    const domConfirmEligibility = document.getElementById('confirm-eligibility')
    if (domConfirmEligibility) {
      ReactDOM.render(<ConfirmEligibility />, domConfirmEligibility)
    }
  }
}

export default Controller
